import { RouteConfig } from 'vue-router';

import { AttachmentType } from '@/enums/attachmentType.enum';
import { EntityType } from '@/enums/entityType.enum';
import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';

export const procedureAttachmentsRoute: RouteConfig = {
  path: 'attachments',
  name: 'procedureAttachments',
  component: () =>
    import(/* webpackChunkName: "ProcedureAttachments" */ '@/views/mainRoute/procedure/details/Attachments.vue'),
  beforeEnter: (to, from, next) => {
    Promise.all([
      store.dispatch('procedure/attachment/list', {
        order: 'order',
        desc: false,
        count: -1,
        entityType: EntityType.PROCEDURE,
        entityId: to.params.procedureId.toString(),
        type: AttachmentType.UPLOADED
      }),
      store.dispatch('auth/checkPermissions', 'PROCEDURE.UPDATE')
    ])

      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.ATTACHMENT_CANNOT_LIST }));
  }
};
